/* On-demand loading for the tabbed sections' inactive panels.

   Those sections used to render every panel server-side even though only one
   is ever visible — about 158 of 196 products built and thrown away on each
   page load. That pushed the homepage past Shopify's render budget, so it
   returned 500s intermittently (and, at its worst, on nearly every load).

   Now only the active panel is rendered with the page. Every other panel ships
   empty with a data-fetch URL pointing at a layout-less collection view, and
   its products are fetched the first time its tab is clicked.

   Exposes window.dodoLoadPanel(panelEl), which each section's tab handler
   calls when it activates a panel. Panels without data-fetch (the active one)
   just get their images unveiled, exactly as before. */
(function () {
  /* Inactive panels are display:none, so the theme's lazy loader never brings
     their images in and a freshly-shown panel would be all blank cards. */
  function unveil(root) {
    if (!root) return;
    var ls = window.lazySizes;
    var nodes = root.querySelectorAll('.lazyload');
    for (var i = 0; i < nodes.length; i++) {
      if (ls && ls.loader && ls.loader.unveil) {
        try { ls.loader.unveil(nodes[i]); } catch (e) {}
      } else {
        nodes[i].classList.add('lazypreload');
      }
    }
    if (ls && ls.loader && ls.loader.checkElems) ls.loader.checkElems();
  }

  function finish(panel) {
    unveil(panel);
    // Lets dodo-hscroll.js bind wheel/drag handling to the new track.
    document.dispatchEvent(new CustomEvent('dodo:panel:loaded', {
      detail: { panel: panel }
    }));
  }

  window.dodoLoadPanel = function (panel) {
    if (!panel) return;

    var url = panel.getAttribute('data-fetch');
    if (!url || panel.getAttribute('data-loaded') || panel.getAttribute('data-loading')) {
      finish(panel);
      return;
    }

    panel.setAttribute('data-loading', '1');
    panel.classList.add('dodo-panel--loading');

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var target = panel.querySelector('[data-fetch-target]') || panel;
        target.innerHTML = html;
        // The fetch view returns a fixed number of cards because Liquid cannot
        // read a query string, so sections that show fewer (Featured Brands
        // shows 8) declare data-limit and the extras are dropped here.
        var limit = parseInt(panel.getAttribute('data-limit'), 10);
        if (limit > 0) {
          while (target.children.length > limit) {
            target.removeChild(target.lastElementChild);
          }
        }
        panel.setAttribute('data-loaded', '1');
        panel.removeAttribute('data-loading');
        panel.classList.remove('dodo-panel--loading');
        finish(panel);
      })
      .catch(function () {
        panel.removeAttribute('data-loading');
        panel.classList.remove('dodo-panel--loading');
        // Leave the panel empty rather than half-filled, and allow a retry on
        // the next click instead of caching the failure.
        var target = panel.querySelector('[data-fetch-target]') || panel;
        target.innerHTML = '<p class="dodo-panel__error">Couldn’t load these products. Please try again.</p>';
      });
  };
})();
